import React, { useState, useCallback, useRef, useEffect } from "react";
import QrScanner from "qr-scanner";
import {
  HttpLogin,
  HttpCheckToken,
  HttpPost,
  HttpGet,
} from "../../providers/HttpClient";
import Axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import MenuBar from "../MenuBar/MenuBar";
import Alert from "../alertComponent/alertComponent";
import { toast } from "react-toastify";

const ChooseLocation = () => {
  const navigate = useNavigate();
  const [locationList, setLocationList] = useState<any>([]);
  const [location, setLocation] = useState("");

  const getLocation = async () => {
    // setLoading(true);
    HttpGet(`member/combo/patrol_location`)
      .then((res: any) => {
        setLocationList(res.data);
        // setLoading(false);
      })
      .catch((err) => {
        // setLoading(false);
      });
  };

  const effectRan = useRef(false);

  useEffect(() => {
    getLocation();
  }, []);

  return (
    <div className="bg-main h-full mb-12">
      <div className="pb-28 ">
        <div className="px-5 py-24 mb-8">
          <label htmlFor="location" className="block text-gray-700">
            Pilihan Lokasi
          </label>
          <select
            value={location}
            onChange={(event) => {
              setLocation(event.target.value);
            }}
            className="bg-white border border-gray-300 rounded-full px-4 py-2 w-full"
          >
            <option disabled value={""}></option>
            {locationList.map((el: any, index: any) => (
              <option key={index} value={el._id}>
                {el.name}
              </option>
            ))}
          </select>
        </div>
      </div>
      <div className="bar fixed z-50 bottom-0 w-full bg-white px-4 py-5">
        {location === "" ? (
          <button
            className={
              "text-center active:bg-zinc-100 rounded-md border border-transparent bg-green-100 px-5 py-2 text-sm font-medium focus:outline-none focus-visible:ring-2 focus-visible:ring-red-500 focus-visible:ring-offset-2 w-full"
            }
          >
            {"Lanjutkan"}
          </button>
        ) : (
          <button
            className={
              "text-center active:bg-zinc-100 rounded-md border border-transparent bg-green-300 px-5 py-2 text-sm font-medium focus:outline-none focus-visible:ring-2 focus-visible:ring-red-500 focus-visible:ring-offset-2 w-full"
            }
            onClick={() => {
              navigate(`/home/patrol-qrcode/${location}`);
            }}
          >
            {"Lanjutkan"}
          </button>
        )}
      </div>
    </div>
  );
};
export default ChooseLocation;
